import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class SubmitButton extends Component {
  static propTypes = {
    children: PropTypes.node,
    submitting: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['submit', 'button'])
  }

  spinner() {
    if (!this.props.submitting) return null;
    return <i className="fa fa-spinner fa-spin" />;
  }

  render() {
    const { type, submitting, onClick } = this.props;
    const spinner = this.spinner();

    return (
      <button
        ref="submitButton"
        type={type || 'submit'}
        className="btn btn-sm btn-default btn-primary modal-submit-btn"
        disabled={submitting}
        onClick={onClick}
      >
        {this.props.children} {spinner}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/SubmitButton/SubmitButton.js